import { render, staticRenderFns } from "./data-table.vue?vue&type=template&id=54c6deda&"
import script from "./data-table.vue?vue&type=script&lang=js&"
export * from "./data-table.vue?vue&type=script&lang=js&"
import style0 from "./data-table.vue?vue&type=style&index=0&id=54c6deda&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54c6deda')) {
      api.createRecord('54c6deda', component.options)
    } else {
      api.reload('54c6deda', component.options)
    }
    module.hot.accept("./data-table.vue?vue&type=template&id=54c6deda&", function () {
      api.rerender('54c6deda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/calculation-sheets/calculation-sheet/additions/data-table.vue"
export default component.exports